import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { resetTraceId } from 'utils/traceIdHelper'

const TraceIdUpdater = () => {
  const location = useLocation()

  useEffect(() => {
    resetTraceId()
  }, [location.pathname])

  return null
}

export default TraceIdUpdater
